/**
 * Retaining Walls Field Mapping
 * Maps field names to their display labels (matching groundworks_rates_mapping.json)
 */

/**
 * Mapping of retaining walls field names to their display labels
 */
export const RETAINING_WALLS_FIELD_LABELS: { [fieldName: string]: string } = {
  // Screen Walls
  'screenWalls': 'Screen Walls',
  'screenWallsEO': 'Screen Walls EO Pillar (Nr)',
  'screenWallsSof': 'Screen Walls Sof 450mm (m)',
  'screenWallsLog': 'Screen Walls Log 1200mm (m)',
  'screenWallsGravelBoard': 'Screen Walls Gravel Board (m)',
  'screenWallsAdditionalExcavation': 'Screen Walls Additional Excavation (m3)',
  'screenWallsAdditionalConcrete': 'Screen Walls Additional Concrete (m3)',

  // Garden Retaining Walls
  'grw450': 'Garden Retaining Wall 450 (m)',
  'grw600': 'Garden Retaining Wall 600 (m)',
  'grw750': 'Garden Retaining Wall 750 (m)',
  'grw900': 'Garden Retaining Wall 900 (m)',
  'grw1050': 'Garden Retaining Wall 1050 (m)',
  'grw1200': 'Garden Retaining Wall 1200 (m)',
  'grw1500': 'Garden Retaining Wall 1500 (m)',
  'grw1800': 'Garden Retaining Wall 1800 (m)',
  'grw2000': 'Garden Retaining Wall 2000 (m)',

  // Concrete Core Walls
  'ccrw1500': 'Concrete Core Wall 1500 (m)',
  'ccrw1800': 'Concrete Core Wall 1800 (m)',
  'ccrw2000': 'Concrete Core Wall 2000 (m)',
  'ccrw2250': 'Concrete Core Wall 2250 (m)',
  'ccrw2500': 'Concrete Core Wall 2500 (m)',
  'ccrw2750': 'Concrete Core Wall 2750 (m)',
  'ccrw3000': 'Concrete Core Wall 3000 (m)',
  'ccrw3250': 'Concrete Core Wall 3250 (m)',
  'ccrw3500': 'Concrete Core Wall 3500 (m)',

  // Drive Retaining Walls
  'drw450': 'Drive Retaining Wall 450 (m)',
  'drw600': 'Drive Retaining Wall 600 (m)',
  'drw750': 'Drive Retaining Wall 750 (m)',
  'drw900': 'Drive Retaining Wall 900 (m)',
  'drw1050': 'Drive Retaining Wall 1050 (m)',
  'drw1200': 'Drive Retaining Wall 1200 (m)',
  'drw1500': 'Drive Retaining Wall 1500 (m)',
  'drw1800': 'Drive Retaining Wall 1800 (m)',
  'drw2000': 'Drive Retaining Wall 2000 (m)',
  'drw2250': 'Drive Retaining Wall 2250 (m)',
  'drw2500': 'Drive Retaining Wall 2500 (m)',
  'drw2750': 'Drive Retaining Wall 2750 (m)',
  'drw3000': 'Drive Retaining Wall 3000 (m)',
};

/**
 * Mapping of retaining walls field names to their units
 */
export const RETAINING_WALLS_FIELD_UNITS: { [fieldName: string]: string } = {
  // Screen Walls
  'screenWalls': 'm',
  'screenWallsEO': 'Nr',
  'screenWallsSof': 'm',
  'screenWallsLog': 'm',
  'screenWallsGravelBoard': 'm',
  'screenWallsAdditionalExcavation': 'm³',
  'screenWallsAdditionalConcrete': 'm³',

  // Garden Retaining Walls
  'grw450': 'm',
  'grw600': 'm',
  'grw750': 'm',
  'grw900': 'm',
  'grw1050': 'm',
  'grw1200': 'm',
  'grw1500': 'm',
  'grw1800': 'm',
  'grw2000': 'm',

  // Concrete Core Walls
  'ccrw1500': 'm',
  'ccrw1800': 'm',
  'ccrw2000': 'm',
  'ccrw2250': 'm',
  'ccrw2500': 'm',
  'ccrw2750': 'm',
  'ccrw3000': 'm',
  'ccrw3250': 'm',
  'ccrw3500': 'm',

  // Drive Retaining Walls
  'drw450': 'm',
  'drw600': 'm',
  'drw750': 'm',
  'drw900': 'm',
  'drw1050': 'm',
  'drw1200': 'm',
  'drw1500': 'm',
  'drw1800': 'm',
  'drw2000': 'm',
  'drw2250': 'm',
  'drw2500': 'm',
  'drw2750': 'm',
  'drw3000': 'm',
};

/**
 * Get the display label for a retaining walls field
 */
export function getRetainingWallsFieldLabel(fieldName: string): string | undefined {
  return RETAINING_WALLS_FIELD_LABELS[fieldName];
}

/**
 * Get the unit for a retaining walls field
 */
export function getRetainingWallsFieldUnit(fieldName: string): string | undefined {
  return RETAINING_WALLS_FIELD_UNITS[fieldName];
}

/**
 * Reverse mapping: label to field name
 */
export const RETAINING_WALLS_REVERSE_MAPPING: { [label: string]: string } = {};
Object.entries(RETAINING_WALLS_FIELD_LABELS).forEach(([fieldName, label]) => {
  RETAINING_WALLS_REVERSE_MAPPING[label] = fieldName;
});
